import type { ProficiencyLevelDefinition } from '@/types/competency/ProficiencyLevelDefinition';

import { api } from '@/api/api';

export interface ProficiencyLevelItemPayload {
    id?: string | null;
    icon: string;
    iconUrl?: string | null;
    iconColor?: string | null;
    label: Record<string, string>;
    sortOrder: number;
}

export interface ProficiencyLevelReplacePayload {
    levels: ProficiencyLevelItemPayload[];
}

export default {
    async getProficiencyLevels(): Promise<ProficiencyLevelDefinition[]> {
        const response = await api.get(`/ProficiencyLevel`);

        return response.data;
    },

    async replaceProficiencyLevels(
        payload: ProficiencyLevelReplacePayload,
    ): Promise<ProficiencyLevelDefinition[]> {
        const response = await api.put(`/ProficiencyLevel`, payload);

        return response.data;
    },
};
